import Header from './modules/header.js';
import Fixed from './modules/fixed.js';
import Accordion from './modules/accordion.js';
import Slider from './modules/slider.js';
import Access from './modules/access.js';
import PageTab from './modules/page-tab.js';
import Remedy from './modules/remedy.js';
import MessageYoutubeModal from './modules/message-youtube-modal.js';
import Check from './pages/check.js';
import Skin from './pages/skin.js';
import Shindouatsu from './pages/shindouatsu.js';

class App {
	constructor() {
		this.routes();
	}

	routes() {
		new Header();
		new Fixed();
		new Accordion();
		new Slider();
		new Access();
		new PageTab();
		new Remedy();
		new MessageYoutubeModal();
		new MessageYoutubeModal({
			modalSelector: '.js-clinic-youtube-modal',
			triggerSelector: '.js-clinic-youtube-trigger',
			iframeSelector: '.js-clinic-youtube-iframe',
			innerSelector: '.p-clinic-youtube-modal__inner',
			closeSelector: '.js-clinic-youtube-close',
			openClass: 'is-clinic-youtube-modal-open',
		});
		new Check(); 
		new Skin(); 
		new Shindouatsu();
	}

}

window.App = new App();
